import { Banner } from "components/Banner/Banner";
import { useUser } from "contexts/User/UserContext";
import { useTranslation } from "i18n";

export const TestOrganizationBanner = () => {
  const t = useTranslation();
  const { organizationCustomerEnvironment } = useUser();

  const isTestOrganization = organizationCustomerEnvironment === "TEST";

  if (!isTestOrganization) return null;

  return (
    <Banner type="warning">{t("test_organization_banner.message")}</Banner>
  );
};
